
import ViewerImages from '@/components/ViewerImages.vue'
export default {
  name: 'ModalReview',
  components: { ViewerImages },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      product: null,
      loadingContent: true,
      expandedMessage: false,
      limitBeforeExpand: 100,
    }
  },
  async fetch() {
    const productId =
      this.review.variant?.product_id ?? this.review.variant?.product?.id
    if (!productId) {
      this.loadingContent = false
      return
    }
    await this.$productService
      .fetchProductModalReviewProduct(productId)
      .then(({ data }) => {
        this.product = {
          ...data,
          variant: data.variant.is_orderable
            ? data.variant
            : data.selectable_variants.find(
                variant => variant.id === this.review.variant.id
              ),
        }
        this.loadingContent = false
      })
  },
  computed: {
    sources() {
      return {
        images: this.review.images,
        movies: this.review.movies,
        name: this.review.message,
      }
    },
  },
  methods: {
    vehicleImageSrc(url, template) {
      if (!url) return null
      return this.$cropUrl(
        { url, url_template: template },
        24,
        '_',
        url.split('.').pop(),
        86
      )
    },
  },
}
